import { aiChatApi, aiProcessingApi } from "utilities/Axios";

export const sendAiRequest = (data: { user_message: string; user_id: string; oid: string; sid: string }) => {
  return aiChatApi.post(`/api/v1/chat/`, {
    ...data,
    project_type: "saas",
  });
};

export const getReports = async ({ oid, sid }: { oid: string; sid: string }) => {
  return aiChatApi.get(`/api/v1/report`, {
    params: {
      oid,
      sid,
      project_type: "saas",
    },
  });
};

export const processDoc = async ({oid, sid, file_id}: {oid: string, sid: string, file_id: string}) => {
  return aiProcessingApi.post(`/api/v1/document/process`, {
    sid,
    oid,
    file_id
  });
};

export const getDocProcessingStatus = async ({file_id}: {file_id: string}) => {
  return aiProcessingApi.get(`/api/v1/document/status/${file_id}`);
};

export const deleteDocMetadata = async ({document_id}: {document_id: string}) => {
  return aiProcessingApi.delete(`/api/v1/document/${document_id}`);
};